/**
 * Locations Services Module
 * Exports all location management services and factory functions
 */
// Service exports
export * from './LocationService';
export * from './AddressService';
export * from './LocationInfoService';
export * from './LocationLeaderService';
export * from './LocationSocialMediaService';
export * from './LocationVenueService';
export * from './ServiceTimeService';
export * from './SocialMediaService';
// Service imports for factory
import { LocationService } from './LocationService';
import { AddressService } from './AddressService';
import { LocationInfoService } from './LocationInfoService';
import { LocationLeaderService } from './LocationLeaderService';
import { LocationSocialMediaService } from './LocationSocialMediaService';
import { LocationVenueService } from './LocationVenueService';
import { ServiceTimeService } from './ServiceTimeService';
import { SocialMediaService } from './SocialMediaService';
/**
 * Create all locations services with shared configuration
 * @param http - HTTP client instance
 * @param config - Service configuration (servicePath, endpoints)
 * @returns Object containing all locations service instances
 */
export function createLocationsServices(http, config) {
    return {
        location: new LocationService(http, config),
        address: new AddressService(http, config),
        locationInfo: new LocationInfoService(http, config),
        locationLeader: new LocationLeaderService(http, config),
        locationSocialMedia: new LocationSocialMediaService(http, config),
        locationVenue: new LocationVenueService(http, config),
        serviceTime: new ServiceTimeService(http, config),
        socialMedia: new SocialMediaService(http, config),
    };
}
//# sourceMappingURL=index.js.map